import { AREA_SEARCH_PROPS } from '../props/area-search'
import { inputSearch } from '../data/api'

export default {
  name: 'KyeAddressSearch',
  props: AREA_SEARCH_PROPS,
  data () {
    return {
      inputLabel: '',
      suffixIcon: 'el-icon-caret-bottom'
    }
  },
  render (h) {
    const { searchOption, placeholder, disabled } = this.$props
    const { inputStyle = {} } = searchOption || {}
    const style = {
      width: '224px',
      ...inputStyle,
    }
    const inputAttrs = {
      props: {
        value: this.inputLabel,
        placeholder,
        disabled
      },
      attrs: {
        'data-autocomplete': 0,
        placeholder
      },
      style,
      on: {
        focus: this.focus,
        blur: this.blur,
      },
      nativeOn: {
        keydown: this.keydown,
        input: this.input,
      },
      ref: 'input',
    }

    let showClear = this.showClear()
    let className = this.createSuffixIcon() + ' el-input__icon'
    return h('el-input', inputAttrs, [
      h('i', {
        slot: 'suffix',
        class: className,
        on: {
          click: (e) => {
            if (disabled) {
              return
            }
            if (showClear) {
              e.stopPropagation()
              this.clear()
            }
          }
        }
      })
    ])
  },
  methods: {
    createSuffixIcon () {
      let showClear = this.showClear()
      let showInputSearchIcon = this.showInputSearchIcon()
      if (showClear) {
        return 'el-icon-circle-close el-input__clear'
      } else if (showInputSearchIcon) {
        return 'el-icon-search el-input__clear kye-area-search-icon'
      } else {
        return this.suffixIcon
      }
    },
    showClear () {
      if (this.$refs.input) {
        return !this.$refs.input.disabled && !this.$refs.input.readonly && this.$refs.input.currentValue !== '' && (this.$refs.input.focused || this.$refs.input.hovering)
      } else {
        return false
      }
    },
    showInputSearchIcon () {
      if (this.$refs.input) {
        return !this.$refs.input.disabled && !this.$refs.input.readonly && !this.$refs.input.currentValue && this.$refs.input.focused
      } else {
        return false
      }
    },
    input (e) {
      try {
        const value = e.target.value
        const keyWord = value.trim()
        inputSearch(keyWord, this.$props.searchOption, this.$props.level).then(result => {
          this.$props.handleSearchInputEvent(result, keyWord)
        })
      } catch (error) {
        console.log(error)
      }
    },
    setInputLabel (label) {
      this.inputLabel = label
      this.$refs.input.currentValue = label
    },
    focus (e) {
      this.$emit('focus', e)
    },
    blur (e) {
      this.$emit('blur', e)
    },
    clear () {
      this.$emit('clear')
      this.setInputLabel('')
    },
    setInputSuffixIcon (name) {
      this.suffixIcon = name
    },
    changeSuffixIcon (show) {
      this.suffixIcon = show ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
    },
    keydown (e) {
      this.$emit('keyDown', e)
    }
  },
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/layout/area-search.js